import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { collectButtonComponentParams } from '../landingButton';
import { collectMediaElementParams } from '../shared/mediaElement';

import { ImageText } from './ImageText';
import { ImageSectionStrapiComponent, ImageTextProps } from './types';

export const collectImageSectionComponentParams = (
  data: ImageSectionStrapiComponent,
  page: PageTypes
): ImageTextProps | undefined => {
  const list = data?.sectionList?.map((x) => ({
    text: x.text,
    icon: x.icon,
  }));

  const media = collectMediaElementParams(data.media);

  if (!media) {
    return undefined;
  }

  return {
    title: data.title,
    description: data.description,
    imagePosition: data.mediaPosition,
    button: collectButtonComponentParams(page, data.button),
    benefitsList: list && list.length > 0 ? list : undefined,
    useNewImageStyle: data.useNewImageStyle,
    media,
  };
};

const collectImageSectionSingleParams = (
  imageSection: ImageSectionStrapiComponent,
  page: PageTypes
): ReactComponentBuildResponse<typeof ImageText> | undefined => {
  const params = collectImageSectionComponentParams(imageSection, page);
  if (!params) {
    return undefined;
  }
  return {
    component: ReactComponentType.ImageSection,
    props: params,
  };
};

export const collectImageSectionParams = (
  _: PageType,
  page: PageTypes
):
  | ReactComponentBuildResponse<typeof ImageText>
  | ReactComponentBuildResponse<typeof ImageText>[]
  | undefined => {
  if (!('imageSection' in page) || !page.imageSection) {
    return undefined;
  }
  if (Array.isArray(page.imageSection)) {
    return page.imageSection
      .map((x) => collectImageSectionSingleParams(x, page))
      .filter((x) => !!x);
  }

  return collectImageSectionSingleParams(page.imageSection, page);
};
